module.exports = __webpack_public_path__ + "static/media/heart.86913551.svg";